<template>
  <v-app>
    <v-app-bar
      :clipped-left="false"
      app light flat style="border-bottom: 1px solid #111 !important"
    >
      <v-toolbar-title class="headline text-uppercase">
        <span>cafeadmin</span>
      </v-toolbar-title>
      <div class="mx-5">
      </div>
      <v-flex>
        <v-btn v-if="profile" text small class="mx-2" href="#/cafes">Столовые</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/cashiers">Кассиры</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/loadmenu">Загрузка меню</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/viewmenu">Просмотр меню</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/cafereports">Продажи</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/xmlreport">Отчёт</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/requests">Заявки</v-btn>
        <v-btn v-if=" profile && profile.orgid === 'kpisp'" text small class="mx-2" href="#/goods">Обеспечение</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/cartdumps">Сброс корзины</v-btn>
        <v-btn v-if="profile" text small class="mx-2" href="#/saletypes">Виды реализации</v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="inAction" indeterminate size="20" color="secondary" class="mx-3"></v-progress-circular>
      <v-card flat light class="py-1 px-2 darkligth" v-if="profile">
        {{profile.email}}
        <v-icon small>vpn_key</v-icon>
        {{profile.orgid}}
      </v-card>
      <v-btn color="secondary" text v-if="(ready === true) && !profile" href="#/login">Войти</v-btn>
      <v-btn color="secondary" text v-if="profile" @click="$store.dispatch('logout')" icon>
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content app>
      <router-view/>
    </v-content>
    <snackbars></snackbars>
    <Confirmation></Confirmation>
  </v-app>
</template>

<script>
import Snackbars from '@/components/Snackbars'
import Confirmation from '@/components/Confirmation'
export default {
  name: 'App',
  data: () => ({}),
  components: { Snackbars, Confirmation },
  computed: {
    ready () {
      return this.$store.state.ready
    },
    profile () {
      return this.$store.state.profile
    },
    inAction () {
      return this.$store.state.tasksInAction > 0
    },
  },
  watch: {
    ready (val) {
      if (val === true && this.profile === null) {
        this.$router.push('login')
      }
    }
  }
}
</script>
<style>
</style>
